export const skillsData = [
  {
    name: 'Web Development',
    icon: 'fa-solid fa-code', // Adjust icon class based on Font Awesome
    description: 'Experienced in building user interfaces and functionalities using HTML, CSS, and JavaScript frameworks like React.',
    level: 'Advanced',
    projects: [
      { title: 'Project 1', link: 'https://...' }, // Add project details
      { title: 'Project 2', link: 'https://...' }, // Add project details
    ],
  },
  {
    name: 'High-Level Tennis',
    icon: 'fa-solid fa-tennis-ball', // Adjust icon class based on Font Awesome (optional)
    description: 'Extensive experience playing, competing, and coaching high-level tennis. Skilled in strategy, technique, and mental fortitude development.',
    level: 'Expert',
    achievements: [ // Replace "achievements" with a more relevant section title if needed
      { title: 'Pasadena Star News Player of the Year', link: 'https://www.pasadenastarnews.com/2015/06/25/arcadias-charles-deng-is-tennis-player-of-the-year/' }
    ],
  },
  {
    name: 'Fitness & Mental Health Coaching',
    icon: 'fa-solid fa-dumbbell', // Adjust icon class based on Font Awesome (optional)
    description: 'Passionate about helping individuals achieve their fitness and mental health goals. Certified coach with expertise in creating personalized programs and fostering a supportive environment.',
    level: 'Advanced',
    certifications: [ // Add certifications if applicable
      'Certification 1',
      'Certification 2',
    ],
  },
  {
    name: 'Content Writing',
    icon: 'fa-solid fa-book-open', // Adjust icon class based on Font Awesome
    description: 'Strong ability to craft engaging and informative written content for various purposes.',
    level: 'Proficient',
    samples: [
      { title: 'Blog Post 1', link: 'https://...' }, // Add sample details
      { title: 'Website Copy', link: 'https://...' }, // Add sample details
    ],
  },
  {
    name: 'Cashier Experience (Chipotle)', // Update name for clarity
    icon: 'fa-solid fa-cash-register', // Adjust icon class based on Font Awesome (optional)
    description: 'Developed strong customer service and cash handling skills while working as a cashier at Chipotle.',
    level: 'Intermediate',
  },
  {
    name: 'Medium Article Writing',
    icon: 'fa-brands fa-medium', // Adjust icon class based on Font Awesome (optional)
    description: 'Experience writing articles on various topics for the Medium platform.',
    level: 'Proficient',
    samples: [
      { title: 'Article 1', link: 'https://...' }, // Add sample details
      { title: 'Article 2', link: 'https://...' }, // Add sample details
    ],
  },
];
